import React from 'react';
import { SelectedFilters } from './SelectedFilters';
import { NbOfItems } from './NbOfItems';
export const StatusBar = () => {
    return (React.createElement("div", { className: "d:flex:xl-up ai:center mb:16 mb:28:xl-up" },
        React.createElement(SelectedFilters, null),
        React.createElement(NbOfItems, null)));
};
